import QueryString from 'qs'
import { MouseEvent, useContext, useEffect, useRef, useState, useCallback } from 'react'
import { isMobile } from 'react-device-detect'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router-dom'
import { getProfile } from '../api/auth'
import { PathContext } from '../App'
import '../css/Header.css'
import '../css/HeaderResponse.css'
import useScrollRestore from '../hooks/useScrollRestore'
import { AFWebLinkType, RNPostMessage, sendConsoleMessage } from '../js/postMessage'
import { delPrevScroll, setRecentlySearchWord } from '../js/script'
import SearchHeader from '../pages/search/SearchHeader'
import ModalCategory from './modals/ModalCategory'
import { useAppContext } from './provider/AppProvider'
import { useCartContext } from './provider/CartProvider'
import { useCommonContext } from './provider/CommonProvider'

export default function Header() {
  const [isCategoryModal, setIsCategoryModal] = useState<boolean>(false) // 카테고리 팝업 출력 유무
  const [profileImage, setProfileImage] = useState()
  const [customClose, setCustomClose] = useState<boolean>(false) // 카테고리 팝업 닫기 버튼 커스텀 (PC only)
  const [isSearch, setIsSearch] = useState<boolean>(false) // 검색창 출력 유무
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [keyword, setKeyword] = useState<string>('')
  const [filterSearch, setFilterSearch] = useState([])
  const [isSearchContainer, setIsSearchContainer] = useState<boolean>(false)
  const [isHome, setIsHome] = useState<boolean>(false)
  const [appDirect, setAppDirect] = useState<boolean>(true)

  const headerRef = useRef<HTMLDivElement>(null)

  const location = useLocation()
  const navigate = useNavigate()
  const { isAppView, setStorageAppValue, appClose, setAppClose } = useAppContext()
  const { cartCount } = useCartContext()
  const { hasAccessToken } = useCommonContext()

  // 이미지 경로
  const imgURL: string = '/images'
  const currentUrl = window.location.pathname
  const parts = currentUrl.split('/')
  const lastPart = parts[parts.length - 1]
  const { allSearch } = useContext(PathContext)

  useScrollRestore()

  useEffect(() => {
    setIsSearchContainer(false)
    setStorageAppValue(isAppView)
  }, [location])

  useEffect(() => {
    const fetchProfile = async () => {
      if (!hasAccessToken || location.pathname.includes('mypaypaid')) return

      try {
        const res = await getProfile()
        const imageUrl = JSON.parse(res.data.additionalInfo)
        setProfileImage(imageUrl?.profileImage)
      } catch (err) {
        console.log(err)
        sendConsoleMessage(`[Error] getProfile error : ${JSON.stringify(err)}`)
      }
    }

    fetchProfile()
  }, [hasAccessToken, location.pathname])

  // useEffect(() => {
  //   const query = QueryString.parse(location.search, {
  //     ignoreQueryPrefix: true,
  //   })
  //   if (query?.direct) {
  //     setAppDirect(!!query.direct)
  //   } else {
  //     setAppDirect(false)
  //   }

  //   if (query?.keyword && location.pathname === '/search/searchResult') {
  //     setKeyword(query.keyword as string)
  //   } else {
  //     setKeyword('')
  //   }
  // }, [location])

  // useEffect(() => {
  //   if (location.pathname === '/') {
  //     setIsHome(true)
  //   } else {
  //     setIsHome(false)
  //   }
  // }, [location])

  useEffect(() => {
    const searchParams = location.search
    const pathname = location.pathname

    // QueryString 파싱 결과를 캐싱
    const query = QueryString.parse(searchParams, { ignoreQueryPrefix: true })

    // direct 상태 업데이트
    setAppDirect(!!query.direct)

    // keyword 상태 업데이트
    if (pathname === '/search/searchResult') {
      setKeyword((query.keyword as string) || '')
    } else {
      setKeyword('')
    }

    // isHome 상태 업데이트
    setIsHome(pathname === '/')
  }, [location.search, location.pathname])

  // 검색창 포커스
  const setInputFocus = (e: boolean) => {
    const target = document.getElementById('inputSearch')
    if (e) {
      target?.blur()
    } else {
      target?.focus()
    }
  }

  const fetchDate = () => {
    const array: any = []
    allSearch.map((el: any) => {
      if (el.productName.includes(searchKeyword)) {
        array.push(el)
      }
      setFilterSearch(array)
    })
  }

  const updateData = async () => {
    fetchDate()
  }

  useEffect(() => {
    updateData()
  }, [searchKeyword, allSearch])

  const confirmNavigation = (path: string) => {
    const confirmed = window.confirm('작성중인 내용은 저장되지 않습니다. 주문을 취소하시겠습니까?')
    if (confirmed) {
      if (isAppView) {
        RNPostMessage(AFWebLinkType.moveToLink, {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}` + path,
        })
        return
      } else {
        navigate(`${path}`)
      }
    } else {
      return false
    }
  }

  const handleLinkClick = (event: any, to: string, navigate: NavigateFunction, location: Location<any>) => {
    // 같은 경로인지 확인
    event.preventDefault()
    if (location.pathname === to) {
      event.preventDefault() // 기본 링크 이동 동작 방지
    } else {
      if (isAppView) {
        RNPostMessage(AFWebLinkType.moveToLink, {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}` + to,
        })
      } else {
        navigate(to) // 새로운 경로로 이동
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // 한글 자음과 모음, 그리고 띄어쓰기를 허용하는 정규 표현식
    const pattern = /^[가-힣A-Za-z\s]+$/
    // const pattern = /^[ㄱ-ㅎ][^ㅏ-ㅣ가-힣].*$/;

    if (pattern.test(e.target.value)) {
      setSearchKeyword(e.target.value)
    } else {
      setSearchKeyword('')
    }
  }

  function isFirstCharSpace(input: string) {
    return input.charAt(0) === ' '
  }

  const getHeaderClassName = useCallback((currentUrl: string, isAppView: boolean, isMobile: boolean): string => {
    if (currentUrl === '/') {
      return isAppView ? 'header_res_wrap' : isMobile ? 'header_wrap home' : 'header_wrap home pc'
    }
    return isAppView || isMobile ? 'header_wrap' : 'header_wrap pc'
  }, [])

  return (
    <>
      <div className={getHeaderClassName(currentUrl, isAppView, isMobile)} ref={headerRef}>
        {/* 모바일 웹 기획전 상세에서만 노출 */}

        {/* 앱 설치 베너: 모바일 웹으로 접근하였을 때만 출력되어야 함 */}
        {currentUrl === '/exhibitiondetail/' + `${lastPart}` && !appClose && isMobile && !isAppView && (
          <div className='applink_bar'>
            <a href='https://aboutfishing.onelink.me/oR5G/ggsxif1g'>
              <img src='/images/app_logo_icon.png' alt='' />
              <div>
                <p>적립금이 부족하다면? 앱에서 코인 받으세요!</p>
                <strong>어바웃피싱 앱으로 보기</strong>
              </div>
            </a>
            <button
              type='button'
              className='applink_close_btn'
              onClick={(): void => {
                setAppClose(true)
              }}
            >
              <img src='/images/icon_w_close.png' alt='' />
            </button>
          </div>
        )}

        <header>
          <div className='logo_nav_wrap'>
            {/* 어바웃피싱 로고 */}
            {location.pathname === '/' ? (
              <>
                <h1>
                  <div
                    onClick={(e): void => {
                      handleLinkClick(e, '/', navigate, location)
                    }}
                  >
                    <img src={`${imgURL}/logo.png`} alt='About Fishing' />
                  </div>
                </h1>
                <div className='header_subtit'>쇼핑</div>
              </>
            ) : appDirect ? (
              location.pathname !== '/' && (
                <button
                  className='header_homebtn'
                  onClick={(): void => {
                    delPrevScroll()
                    navigate('/')
                  }}
                >
                  <img src={`${imgURL}/icon_home.png`} alt='' />
                </button>
              )
            ) : (
              <>
                <button
                  type='button'
                  className='header_backbtn'
                  onClick={(): void => {
                    if (isAppView && location.pathname === '/orderFinish') {
                      RNPostMessage(AFWebLinkType.onClose, { eventType: 'all' })
                    } else if (isAppView && location.pathname !== '/orderFinish') {
                      RNPostMessage(AFWebLinkType.goBack)
                    } else {
                      navigate(-1)
                    }
                  }}
                >
                  <img src={`${imgURL}/icon_back.png`} alt='' />
                </button>
              </>
            )}
            {!isMobile && !isHome && (
              <h1>
                <div
                  onClick={(e): void => {
                    if (location.pathname.includes('/order/')) {
                      confirmNavigation('/')
                    } else {
                      handleLinkClick(e, '/', navigate, location)
                    }
                  }}
                >
                  <img src={`${imgURL}/logo.png`} alt='About Fishing' />
                </div>
              </h1>
            )}
            {/* 1depth 웹(only): 768px 이상 화면에서만 보임 */}
          </div>

          <div className='search_icon_wrap'>
            {/* 검색영역(웹 Only) */}

            <div
              className='search_container'
              onMouseEnter={() => {
                if (isSearch) {
                  setIsSearchContainer(true)
                }
              }}
              onMouseLeave={() => {
                setIsSearchContainer(false)
              }}
            >
              <div className='search'>
                <input
                  id='inputSearch'
                  type='text'
                  value={keyword}
                  placeholder='검색어를 입력해 보세요.'
                  onFocus={() => {
                    setIsSearch(true)
                  }}
                  onBlur={() => {
                    setIsSearch(false)
                    // setSearchKeyword("");
                    // setFilterSearch([]);
                  }}
                  onChange={(e) => {
                    updateData()
                    handleChange(e)
                    setKeyword(e.target.value)
                  }}
                  // 키보드에서 엔터키를 누르면 검색이 되도록
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      if (keyword && !isFirstCharSpace(keyword)) {
                        if (location.pathname.includes('/order/')) {
                          confirmNavigation(`/search/searchResult?keyword=${keyword}`)
                        } else {
                          setInputFocus(true)
                          setRecentlySearchWord(keyword)
                          navigate(`/search/searchResult?keyword=${keyword}`)
                          setIsSearch(false)
                          setIsSearchContainer(false)
                          setKeyword('')
                          setFilterSearch([])
                          setSearchKeyword('')
                        }
                      } else {
                        alert('첫자리 공백은 검색이 불가합니다.')
                      }
                    }
                  }}
                />
                {keyword && (
                  <button
                    className='btn_close'
                    onClick={(): void => {
                      setKeyword('')
                      setSearchKeyword('')
                      setFilterSearch([])
                      setIsSearch(false)
                      setInputFocus(false)
                    }}
                  >
                    <img src={`${imgURL}/icon_clear_button_gray.png`} alt='' />
                  </button>
                )}
                <button>
                  <img
                    src={`${imgURL}/icon_search.png`}
                    alt='검색'
                    onClick={(e: MouseEvent<HTMLImageElement>): void => {
                      e.preventDefault()
                      if (keyword && !isFirstCharSpace(keyword)) {
                        if (location.pathname.includes('/order/')) {
                          confirmNavigation(`/search/searchResult?keyword=${keyword}`)
                        } else {
                          setInputFocus(true)
                          setRecentlySearchWord(keyword)
                          navigate(`/search/searchResult?keyword=${keyword}`)
                          setIsSearch(false)
                          setIsSearchContainer(false)
                          setKeyword('')
                          setFilterSearch([])
                          setSearchKeyword('')
                        }
                      } else {
                        alert('첫자리 공백은 검색이 불가합니다.')
                      }
                    }}
                  />
                </button>
                {/* 검색 결과창 */}
                {isSearch || isSearchContainer ? (
                  <SearchHeader
                    keyword={searchKeyword}
                    setKeyword={setKeyword}
                    filterSearch={filterSearch}
                    setIsSearch={setIsSearch}
                    setSearchKeyword={setSearchKeyword}
                  />
                ) : null}
              </div>
            </div>
            {/* 아이콘 영역 */}

            {/* 앱에서 마이쇼핑 */}
            {location.pathname === '/myshopping' && isAppView ? (
              <div className='icon_container'>
                {/* 장바구니 페이지 이동 */}
                <button
                  className='cart'
                  onClick={(e): void => {
                    const query = location.search
                    if (query.includes('newwebview=true') && query.includes('direct=true')) {
                      navigate('/cart', { state: { newwebview: true } })
                    } else if (location.pathname.includes('/order/')) {
                      confirmNavigation('/cart')
                    } else {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                        })
                      } else {
                        navigate('/cart')
                      }
                    }
                  }}
                >
                  <img src={`${imgURL}/icon_cart.png`} alt='장바구니' />
                  {cartCount === 0 ? null : <span>{cartCount}</span>}
                </button>

                {/* 앱 설정 페이지 이동 */}
                {hasAccessToken ? (
                  <button
                    className='setting'
                    onClick={(): void => {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: 'aboutfishing://aboutfishing.com/?page=setting',
                      })
                    }}
                  >
                    <img src={`${imgURL}/icon_setting.png`} alt='설정' />
                  </button>
                ) : null}
              </div>
            ) : (
              <div className='icon_container'>
                {/* 검색 페이지 이동 */}
                <button
                  onClick={(e): void => {
                    if (location.pathname.includes('/order/')) {
                      confirmNavigation('/search')
                    } else {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search`,
                        })
                      } else {
                        navigate('/search')
                      }
                    }
                  }}
                >
                  <img src={`${imgURL}/icon_search.png`} alt='검색' />
                </button>

                {/* 장바구니 페이지 이동 */}
                <button
                  className='cart'
                  onClick={(e): void => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                      })
                    } else {
                      navigate('/cart')
                    }
                  }}
                >
                  <img src={`${imgURL}/icon_cart.png`} alt='장바구니' />

                  {cartCount === 0 ? null : <span>{cartCount}</span>}
                </button>

                {/* 마이쇼핑 페이지 이동 */}
                <div
                  className='profile_area'
                  onClick={(e): void => {
                    e.preventDefault()
                    if (location.pathname.includes('/order/')) {
                      confirmNavigation('/myshopping')
                    } else {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/myshopping`,
                        })
                      } else {
                        navigate('/myshopping')
                      }
                    }
                  }}
                >
                  <div className='profile'>
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundImage: profileImage ? `url(${profileImage})` : `url(${imgURL}/noprofile_img.png)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        overflow: 'hidden',
                        borderRadius: '50%',
                        boxShadow: '0 0 0 1px rgb(0%, 0%, 0%, 0.05) inset',
                      }}
                    ></div>
                  </div>
                </div>

                {/* 카테고리 페이지 팝업 */}
                <button className='header_category_btn'>
                  {!isMobile ? (
                    <>
                      {isCategoryModal ? (
                        <img
                          src={`${imgURL}/icon_close.png`}
                          alt='카테고리 닫기'
                          onClick={(): void => {
                            setCustomClose(true)
                          }}
                        />
                      ) : (
                        <img
                          src={`${imgURL}/icon_category.png`}
                          alt='카테고리'
                          onClick={(): void => {
                            document.getElementsByTagName('body')[0].style.overflow = 'hidden'
                            setIsCategoryModal(true)
                            setCustomClose(false)
                          }}
                        />
                      )}
                    </>
                  ) : (
                    // <img src={`${imgURL}/icon_category.svg`} alt='카테고리' />
                    <img
                      src={`${imgURL}/icon_category.png`}
                      alt='카테고리'
                      onClick={(): void => {
                        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
                        setIsCategoryModal(true)
                      }}
                    />
                  )}
                </button>
              </div>
            )}
          </div>
        </header>
      </div>
      {isCategoryModal && (
        <ModalCategory
          isCategoryModal={isCategoryModal}
          setIsCategoryModal={setIsCategoryModal}
          customClose={customClose}
        />
      )}
    </>
  )
}
